import { API } from "./api";

/** Laravel JsonResponseAPI::ofPaginatedData shape */
function normalizePaginated(response) {
  const inner = response?.data;
  const rows = Array.isArray(inner?.data) ? inner.data : [];
  const lastPage = inner?.last_page ?? response?.lastPage ?? 1;
  return {
    rows,
    meta: {
      currentPage: inner?.current_page ?? response?.currentPage ?? 1,
      lastPage,
      total: inner?.total ?? response?.total ?? 0,
      perPage: inner?.per_page ?? response?.perPage ?? 20,
      hasMorePages: response?.hasMorePages ?? false,
    },
  };
}

export const settlementApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformLedger: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          per_page = 20,
          company_id,
          branch_id,
          direction,
          category,
          from_date,
          to_date,
        } = params;
        const searchParams = new URLSearchParams();
        searchParams.set("page", String(page));
        searchParams.set("per_page", String(per_page));
        if (company_id) searchParams.set("company_id", String(company_id));
        if (branch_id) searchParams.set("branch_id", String(branch_id));
        if (direction) searchParams.set("direction", direction);
        if (category) searchParams.set("category", category);
        if (from_date) searchParams.set("from_date", from_date);
        if (to_date) searchParams.set("to_date", to_date);
        const qs = searchParams.toString();
        return {
          url: `/admins/platform-ledger?${qs}`,
          method: "GET",
        };
      },
      transformResponse: (response) => normalizePaginated(response),
      providesTags: [{ type: "PlatformSettlementLedger", id: "LIST" }],
    }),

    getBranchWithdrawalsQueue: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          per_page = 20,
          company_id,
          branch_id,
          status,
        } = params;
        const searchParams = new URLSearchParams();
        searchParams.set("page", String(page));
        searchParams.set("per_page", String(per_page));
        if (company_id) searchParams.set("company_id", String(company_id));
        if (branch_id) searchParams.set("branch_id", String(branch_id));
        if (status) searchParams.set("status", status);
        const qs = searchParams.toString();
        return {
          url: `/admins/branch-withdrawals?${qs}`,
          method: "GET",
        };
      },
      transformResponse: (response) => normalizePaginated(response),
      providesTags: [{ type: "BranchWithdrawalsQueue", id: "LIST" }],
    }),

    approveBranchWithdrawal: builder.mutation({
      query: (id) => ({
        url: `/admins/branch-withdrawals/${id}/approve`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "BranchWithdrawalsQueue", id: "LIST" },
        { type: "PlatformSettlementLedger", id: "LIST" },
      ],
    }),

    finalizeBranchWithdrawalTransfer: builder.mutation({
      query: ({ id, otp }) => ({
        url: `/admins/branch-withdrawals/${id}/finalize-transfer`,
        method: "POST",
        body: { otp },
      }),
      invalidatesTags: [
        { type: "BranchWithdrawalsQueue", id: "LIST" },
        { type: "PlatformSettlementLedger", id: "LIST" },
      ],
    }),

    rejectBranchWithdrawal: builder.mutation({
      query: ({ id, reason }) => ({
        url: `/admins/branch-withdrawals/${id}/reject`,
        method: "POST",
        body: reason ? { reason } : {},
      }),
      invalidatesTags: [{ type: "BranchWithdrawalsQueue", id: "LIST" }],
    }),

    getBranchWalletsForCompany: builder.query({
      query: ({ companyId, branch_id }) => {
        const searchParams = new URLSearchParams();
        if (branch_id) searchParams.set("branch_id", String(branch_id));
        const qs = searchParams.toString();
        return {
          url: `/admins/cooperatives/${companyId}/branch-wallets${qs ? `?${qs}` : ""}`,
          method: "GET",
        };
      },
      transformResponse: (res) => res?.data ?? [],
    }),
  }),
});

export const {
  useGetPlatformLedgerQuery,
  useGetBranchWithdrawalsQueueQuery,
  useApproveBranchWithdrawalMutation,
  useFinalizeBranchWithdrawalTransferMutation,
  useRejectBranchWithdrawalMutation,
  useGetBranchWalletsForCompanyQuery,
} = settlementApi;
